import * as dagreD3 from 'dagre-d3'
import * as d3 from 'd3'
import * as R from 'ramda'

// Converted this function to JS to avoid strange compilatiton issue with typescript
export default function renderGraph(svgElement, svgGroupElement, d3Graph, onSelectNode, onSelectEdge, focusNodeId) {
  if (d3Graph && svgElement && svgGroupElement) {
    const render = new dagreD3.render()
    const inner = d3.select(svgGroupElement)
    render(inner, d3Graph)

    // hover tooltips from graph options (native SVG <title>)
    inner.selectAll('g.node').each(function(d) {
      const opts = d3Graph.node(d)
      if (opts && opts.tooltip) {
        d3.select(this).append('title').text(opts.tooltip)
      }
    })
    inner.selectAll('g.edgePath').each(function(d) {
      const opts = edgeOptions(d3Graph, d)
      if (opts && opts.tooltip) {
        d3.select(this).append('title').text(opts.tooltip)
      }
    })

    // dagre applies edge classes only to the path, not the label — mirror them so
    // label text can be styled per state (visited / selected)
    inner.selectAll('g.edgeLabel').each(function(d) {
      const opts = edgeOptions(d3Graph, d)
      if (opts && opts.class) {
        d3.select(this).attr('class', function() {
          return (d3.select(this).attr('class') || '') + ' ' + opts.class
        })
      }
    })

    inner.selectAll('g.node, g.node rect, g.node ellipse, g.node text').on('click', function(d, _i) {
      if (onSelectNode) {
        onSelectNode(d)
      }
    })

    inner.selectAll('g.edgeLabel text').on('click', function(d, _i) {
      // console.log('On Select Edge', d, _i, arguments)
      if (onSelectEdge) {
        onSelectEdge(d.name)
      }
    })

    // Set up zoom support
    const svg = d3.select(svgElement)
    const zoom = d3.zoom().on('zoom', function() {
      inner.attr('transform', d3.event.transform)
    })
    svg.call(zoom)

    // initial focus — put the current node ~100px from the top (it stays in the
    // initial glance on the scrollable page), centered horizontally; fall back
    // to fitting the whole graph when there is no current node
    const w = svgElement.clientWidth || parseFloat(svgElement.getAttribute('width')) || 600
    const h = svgElement.clientHeight || parseFloat(svgElement.getAttribute('height')) || 1000
    let transform = null
    if (focusNodeId && d3Graph.hasNode(focusNodeId)) {
      const n = d3Graph.node(focusNodeId)
      if (n && n.x !== undefined) {
        transform = d3.zoomIdentity.translate(w / 2 - n.x, 100 + (n.height || 0) / 2 - n.y)
      }
    }
    if (!transform) {
      const g = d3Graph.graph()
      if (g && g.width) {
        const scale = Math.min(1, (w - 40) / g.width, (h - 40) / g.height)
        transform = d3.zoomIdentity
          .translate((w - scale * g.width) / 2, (h - scale * g.height) / 2)
          .scale(scale)
      }
    }
    if (transform) svg.call(zoom.transform, transform)
  }
}

function edgeOptions(d3Graph, d) {
  if (!d || d.v === undefined) return null
  try {
    return d3Graph.edge(d.v, d.w, d.name)
  } catch (e) {
    return null
  }
}

